// extracted by mini-css-extract-plugin
module.exports = {"singlePath":"Paths_singlePath__IKHww","container":"Paths_container__TpdRr"};